import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { OrganizationUnitService } from '../../shared/services/organization-units/organization-unit.service';
import { isMainVisibleForOrgType } from '../../shared/services/client-config';

/**
 * Restringe el acceso al módulo de Comunidad/Networking en función del flag
 * `environment.main.community`. Si la organización del usuario no está
 * autorizada, redirige a la raíz.
 */
export const communityFlagGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const orgService = inject(OrganizationUnitService);
  const router = inject(Router);

  if (!(await authService.isLoggedIn())) {
    return router.createUrlTree(['/']);
  }

  let orgType = orgService.organization()?.type;
  if (!orgType) {
    try {
      const org = await firstValueFrom(orgService.getByUser());
      orgType = org?.type;
    } catch {
      orgType = undefined;
    }
  }

  if (isMainVisibleForOrgType('community', orgType)) {
    return true;
  }

  return router.createUrlTree(['/']);
};
